"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var minRows = 1;

var TextArea = function (_a) {
  var maxLength = _a.maxLength,
      error = _a.error,
      field = _a.field,
      label = _a.label,
      className = _a.className,
      basic = _a.basic,
      placeholder = _a.placeholder,
      helperText = _a.helperText,
      helperIcon = _a.helperIcon,
      helperIconColor = _a.helperIconColor,
      disabled = _a.disabled,
      onBlur = _a.onBlur,
      textareaLineHeight = _a.textareaLineHeight,
      showEditIcon = _a.showEditIcon,
      labelIcon = _a.labelIcon,
      includeSeparator = _a.includeSeparator;

  var _b = (0, react_1.useState)(false),
      focus = _b[0],
      setFocus = _b[1];

  var ref = (0, react_1.useRef)();
  var editIconClass = "edit-icon " + (!showEditIcon && 'transition');
  var containerClass = "textarea-container " + className;

  if (error.length > 0) {
    containerClass += ' error';
  }

  if (focus) {
    containerClass += ' focus';
  }

  if (basic) {
    containerClass += ' basic';
  }

  if ((field.value || focus) && !basic) {
    containerClass += ' label-lifted';
  }

  if (showEditIcon && !field.value && !focus) {
    containerClass += ' show-edit-icon';
  }

  if (field.value || focus) {
    containerClass += ' show-count';
  }

  var handleOnBlur = function () {
    setFocus(false);
    if (onBlur) onBlur();
  };

  (0, react_1.useLayoutEffect)(function () {
    if (ref.current) {
      ref.current.rows = minRows;
      var currentRows = Math.floor(ref.current.scrollHeight / textareaLineHeight);
      ref.current.rows = Math.ceil(Math.max(currentRows, minRows));
    }
  }, [field, textareaLineHeight]);

  var renderHelperText = function () {
    return helperText && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "helper-text"
    }, {
      children: [helperIcon && (0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: helperIcon,
        className: "fill helper-icon icon-" + helperIconColor,
        width: 16
      }, void 0), helperText]
    }), void 0);
  };

  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "textarea-fieldset fieldset",
    "data-testid": "text-area-fieldset-" + field.name
  }, {
    children: [error.length > 0 && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "a-form-error",
      "data-testid": "text-area-validation-message-" + field.name
    }, {
      children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: "alert",
        className: "fill icon-error input-error-icon",
        "data-testid": field.name + "-error-icon",
        width: 16
      }, void 0), (0, jsx_runtime_1.jsx)("span", {
        children: error
      }, void 0)]
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: containerClass,
      "data-testid": "textarea-container"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("label", __assign({
        className: "text-area-control-label",
        htmlFor: field.name,
        "data-testid": "text-area-control-label-" + field.name
      }, {
        children: [labelIcon && (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: labelIcon,
          className: "fill label-icon",
          "data-testid": "label-" + labelIcon + "-icon",
          width: 16
        }, void 0), label, basic && renderHelperText(), includeSeparator && (0, jsx_runtime_1.jsx)("div", {
          className: "separator"
        }, void 0)]
      }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "text-area-container"
      }, {
        children: [(0, jsx_runtime_1.jsx)("textarea", {
          className: "text-area",
          id: field.name,
          name: field.name,
          value: field.value || '',
          "scroll-height": 32,
          rows: 1,
          placeholder: basic ? placeholder : null,
          "data-testid": "text-area-" + field.name,
          onChange: field.onChange || function () {},
          onFocus: function () {
            return setFocus(true);
          },
          onBlur: handleOnBlur,
          ref: ref,
          disabled: disabled
        }, void 0), (!basic || showEditIcon) && (0, jsx_runtime_1.jsx)("span", __assign({
          className: editIconClass
        }, {
          children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
            name: "pencil",
            className: "" + (className || 'fill'),
            width: 20
          }, void 0)
        }), void 0)]
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: !basic && helperText ? 'helper-flex' : 'helper'
    }, {
      children: [!basic && renderHelperText(), maxLength && (0, jsx_runtime_1.jsx)(index_1.CharacterCount, {
        value: field.value,
        maxLength: maxLength,
        testId: field.name
      }, void 0)]
    }), void 0)]
  }), void 0);
};

TextArea.propTypes = {
  field: (0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.string,
    onChange: prop_types_1.func
  }),
  maxLength: prop_types_1.number,
  error: prop_types_1.string,
  label: prop_types_1.string,
  className: prop_types_1.string,
  placeholder: prop_types_1.string,
  helperText: prop_types_1.string,
  helperIcon: prop_types_1.string,
  helperIconColor: prop_types_1.string,
  basic: prop_types_1.bool,
  disabled: prop_types_1.bool,
  showEditIcon: prop_types_1.bool,
  includeSeparator: prop_types_1.bool,
  textareaLineHeight: prop_types_1.number
};
TextArea.defaultProps = {
  field: {
    name: '',
    value: '',
    onChange: function () {}
  },
  maxLength: null,
  error: '',
  label: '',
  className: '',
  placeholder: null,
  helperText: '',
  helperIcon: '',
  helperIconColor: '',
  basic: false,
  showEditIcon: false,
  disabled: false,
  textareaLineHeight: 32
};
exports.default = TextArea;